import React, { memo } from 'react';
import { ActivityCard } from './ActivityCard';
import { Activity, ActivitiesModel } from '../Interfaces/interfaces';
import { useAppState } from '../../AppStateContext';

import './Activities.less';

export const Activities = memo(() => {
  const { sugs, categories, products } = useAppState();
  const activityModel: ActivitiesModel = window._THULEDATA._siteHeader.SearchActivities;

  if (sugs.length || categories.length || products.length || !activityModel?.Activities?.length) return null;

  return (
    <div className="activities pb-8">
      <p className="paragraph--s text-color--gray60 mb-6">{activityModel.Header}</p>
      <div className="activities-content">
        {activityModel.Activities.map((activity: Activity, index: number) => (
          <ActivityCard activity={activity} key={index} />
        ))}
      </div>
    </div>
  );
});
